/**
 * Dates and times, rendered the one way this product renders them.
 *
 * `YYYY-MM-DD HH:MM:SS KST`, always. Never a locale format: `toLocaleString`
 * renders the same instant differently for different readers, which for a
 * record of when something happened is a defect rather than a courtesy.
 *
 * Korea Standard Time is a fixed offset with no daylight saving, so shifting
 * the instant and reading it back in UTC gives Seoul wall-clock time whatever
 * timezone the reader's machine is set to.
 */

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

const pad = (n) => String(n).padStart(2, "0");

const shifted = (epochSeconds) => new Date(epochSeconds * 1000 + KST_OFFSET_MS);

/** `YYYY-MM-DD`, in Seoul. */
export const formatKstDate = (epochSeconds) => {
    if (!epochSeconds) return "";
    const d = shifted(epochSeconds);
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
};

/** `HH:MM:SS`, in Seoul, 24-hour. */
export const formatKstTime = (epochSeconds) => {
    if (!epochSeconds) return "";
    const d = shifted(epochSeconds);
    return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
};

/** `YYYY-MM-DD HH:MM:SS KST`, the full form. */
export const formatKst = (epochSeconds) => {
    if (!epochSeconds) return "";
    return `${formatKstDate(epochSeconds)} ${formatKstTime(epochSeconds)} KST`;
};
